import { HeartIcon, UsersIcon, BriefcaseIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import type { Category } from "@/constants/forms";

const CATEGORIES = [
  {
    key: "dating" as const,
    icon: HeartIcon,
    title: "Encontros",
    desc: "Perfis de namoro e apelo romântico",
  },
  {
    key: "social" as const,
    icon: UsersIcon,
    title: "Social",
    desc: "Presença em redes sociais e acessibilidade",
  },
  {
    key: "business" as const,
    icon: BriefcaseIcon,
    title: "Profissional",
    desc: "Fotos profissionais e credibilidade",
  },
];

interface CategoryStepProps {
  selectedCategory: Category | null;
  onSelect: (category: Category) => void;
}

export function CategoryStep({ selectedCategory, onSelect }: CategoryStepProps) {
  return (
    <div className="flex flex-col gap-3 md:grid md:grid-cols-3">
      {CATEGORIES.map(({ key, icon: Icon, title, desc }) => (
        <button
          key={key}
          type="button"
          className={cn(
            "flex items-center gap-4 rounded-lg border px-4 py-3 text-left transition-all md:flex-col md:items-center md:gap-2 md:px-4 md:py-5 md:text-center",
            selectedCategory === key
              ? "border-primary bg-primary/10"
              : "border-border bg-card hover:bg-accent/10"
          )}
          onClick={() => onSelect(key)}
        >
          <div
            className={cn(
              "flex h-10 w-10 shrink-0 items-center justify-center rounded-full md:h-12 md:w-12",
              selectedCategory === key ? "bg-primary/20" : "bg-muted"
            )}
          >
            <Icon
              className={cn(
                "h-5 w-5 md:h-6 md:w-6",
                selectedCategory === key ? "text-primary" : "text-muted-foreground"
              )}
            />
          </div>
          <div>
            <h3 className="font-semibold">{title}</h3>
            <p className="text-xs text-muted-foreground">{desc}</p>
          </div>
        </button>
      ))}
    </div>
  );
}
